import React from 'react';
import LuckyWheelCouponForm from './form';
import {notification} from 'antd';
import history from '../../../modules/History';
import {addLuckyWheelCoupon} from '../../../modules/Api';

class AddLuckyWheelCoupon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: { lucky_wheel_id: props.match.params.lucky_wheel_id},
            submitted: false,
        }

    }

    submit(values) {
        if(this.state.submitted){
            return;
        }

        this.setState({submitted: true});
        addLuckyWheelCoupon(this.state.data.lucky_wheel_id, values, (res) => {
            this.setState({submitted:false});

            if(res.status==200){
                notification.open({
                    message: `اطلاعات با موفقیت ویرایش شد!`,
                });
                history.item.push(`/lucky_wheels/coupons/` + this.state.data.lucky_wheel_id);
            }
            else if(res.message != undefined){
                notification.open({
                    message: res.message,
                });
            }
        });
    }
    render() {
        return (<LuckyWheelCouponForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/>);
    }
}

export default AddLuckyWheelCoupon;


// WEBPACK FOOTER //
// ./src/containers/LuckyWheels/Coupons/add.js